/** Document source enumeration */
export enum DocumentSourceEnum {
  /** Document received from 1C ERP database */
  ERP_1C = 'ERP_1C',
  /** Document created by FRM */
  FRM = 'FRM',
  /** Document created by bank statement */
  BANK_STATEMENT = 'BANK_STATEMENT',
  /** Document create from balance sheet report */
  BALANCE_SHEET = 'BALANCE_SHEET',
}
